import {
  VolumeDown,
  VolumeMute,
  VolumeOff,
  VolumeUp,
} from "@mui/icons-material";
import { Button, IconButton, Popover, Slider, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { glassColor } from "./Colors";

export default function VolumeSlider() {
  var [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  var [popoverOpen, setPopoverOpen] = useState(false);

  function setVolume(value: number) {
    localStorage.setItem("local-volume", value.toString());
    document.querySelectorAll("audio").forEach((audio) => {
      (audio as HTMLAudioElement).volume = value / 100;
    });
  }

  const [volume, setVolumeState] = useState(
    localStorage.getItem("local-volume")
      ? parseInt(localStorage.getItem("local-volume")!)
      : 100
  );

  function getIcon() {
    if (volume === 0) {
      return <VolumeOff />;
    } else if (volume < 50) {
      return <VolumeDown />;
    } else {
      return <VolumeUp />;
    }
  }

  useEffect(() => {
    // Set the initial volume when the component mounts
    setVolume(volume);
  }, [volume]);

  return (
    <div style={{ display: "inline-block", marginRight: "0.5em" }}>
      <Tooltip title="Browser Volume">
        <IconButton
        color="secondary"
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
          setPopoverOpen(true);
        }}
      >
        {getIcon()}
      </IconButton>
      </Tooltip>
      
      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={() => setPopoverOpen(false)}
        sx={{}}
        slotProps={{
          paper: {
            sx: {
              paddingLeft: 2,
              paddingRight: 2,
              paddingTop: 1,
              paddingBottom: 1,
              backgroundColor: glassColor(true, 0.4),
              color: "secondary.main",
              backdropFilter: "blur(10px)",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "fit-content",
              justifyContent: "space-between",
              overflow: "hidden",
            },
          },
        }}
      >
        <Typography fontWeight={"bold"} fontSize={14}>
          Browser Volume
        </Typography>
        <Slider
          color="secondary"
          defaultValue={
            localStorage.getItem("local-volume")
              ? parseInt(localStorage.getItem("local-volume")!)
              : 100
          }
          value={volume}
          min={0}
          max={100}
          sx={{
            width: "200px",
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === "number") {
              setVolume(newValue);
              setVolumeState(newValue);
            }
          }}
        />
      </Popover>
    </div>
  );
}
